import $ from 'jquery';
import 'jquery-ui/ui/widgets/slider';

export default class Range {
  constructor(range) {
    const $range = $(range);

    this.$ = {
      range: $range,
      slider: $range.find('.js-filter-range-slider'),
      from: $range.find('.js-filter-range-from'),
      to: $range.find('.js-filter-range-to')
    };

    this.init();
  }
  init() {
    this.param = {
      MIN: this.$.slider.data('min') || 10,
      MAX: this.$.slider.data('max') || 1000,
      STEP: this.$.slider.data('step') || 5,
      start: Number(this.$.from.val()),
      end: Number(this.$.to.val())
    };

    this.DEFAULT = [this.param.start, this.param.end];

    this.events();
    this.setFieldsAttr();
    this.slider();
  }
  events() {
    this.$.from.on('change', { type: 'FROM' }, this.handler.bind(this));
    this.$.to.on('change', { type: 'TO' }, this.handler.bind(this));
  }
  setFieldsAttr() {
    this.$.from.attr({ min: this.param.MIN, max: this.param.MAX });
    this.$.to.attr({ min: this.param.MIN, max: this.param.MAX });
  }
  slider() {
    this.$.slider.slider({
      range: true,
      min: this.param.MIN,
      max: this.param.MAX,
      step: this.param.STEP,
      values: this.DEFAULT,
      slide: (e, ui) => {
        this.param.start = ui.values[0];
        this.param.end = ui.values[1];
        this.$.from.val(this.param.start);
        this.$.to.val(this.param.end);
      },
      stop: (e, ui) => {
        this.$.from.change();
      }
    });
  }
  update() {
    this.$.slider.slider({
      values: [this.param.start, this.param.end]
    });

    this.$.from.val(this.param.start);
    this.$.to.val(this.param.end);
  }
  handler(e) {
    const $target = $(e.target);
    const type = e.data.type;

    this.setValue(type);
    this.validate(type, $target);
    this.update();
  }
  validate(type, $target) {
    const MIN = Number(this.param.MIN);
    const MAX = Number(this.param.MAX);
    const VALUE = Number($target.val());

    const condition = value =>
      !this.isInteger(VALUE) || VALUE < MIN || VALUE >= MAX;

    this.getMethod(
      {
        FROM: () =>
          (this.param.start = condition(VALUE) ? MIN : this.param.start),
        TO: () => (this.param.end = condition(VALUE) ? MAX : this.param.end)
      },
      type
    ).call(this);

    this.update();
  }
  isInteger(value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  }
  setValue(type) {
    this.getMethod(
      {
        FROM: () => (this.param.start = Number(this.$.from.val())),
        TO: () => (this.param.end = Number(this.$.to.val()))
      },
      type
    ).call(this);
  }
  getMethod(map, type) {
    return map[type];
  }
  reset() {
    const [start, end] = this.DEFAULT;

    this.param.start = start;
    this.param.end = end;
    this.$.from.val(start);
    this.$.to.val(end);

    this.update();
  }
}
